// Wirkung von Gesetzen jenseits des eigenen Problems: Nebenwirkungen (Zielkonflikte), Synergien,
// schwankende Umsetzung und Überraschungen nach Inkrafttreten.
import { ISS } from '../content/states';
import { SYNERGY } from '../content/issues_more';
import { OUTLETS } from '../content/parties';
import { applyEff } from './economy';
import { press } from './media';
import { rnd } from './rng';
import { S, log } from './state';
import { clamp, sg } from './util';

/** Nebenwirkung eines wirkenden Gesetzes für einen Monat (Gesamtwirkung über sechs Monate verteilt). */
export function sideMonth(L: any) {
  const side = L.fx?.side; if (!side) return;
  for (const k in side) {
    const st = S.issues[k]; if (!st) continue;
    st.sev = clamp(st.sev + side[k] / 6 * (L.q || 1), 0, 100);
    if (side[k] > 0 && !st.on && st.sev >= 25) { st.on = true; st.solved = null; log(`Nebenwirkung von „${L.t}“: ${ISS[k].n} wird zum Thema.`, 'bad'); }
  }
}

/** Beim Inkrafttreten: Umsetzung schwankt (±25 %), Synergien mit bestehenden Gesetzen werden geprüft. */
export function onEnact(L: any) {
  if (L.rep || L.bestand) return;
  const luck = Math.round((.75 + rnd() * .5) * 100) / 100;
  L.luck = luck; L.q = (L.q || 1) * luck;
  if (luck < .85) { log(`Holprige Umsetzung: „${L.t}“ wirkt schwächer als geplant (${Math.round(luck * 100)} %).`, 'bad'); press(OUTLETS[1].n, `Pannen bei „${L.t}“: Ämter kommen mit der Umsetzung nicht hinterher`, -.3); }
  else if (luck > 1.15) { log(`„${L.t}“ wirkt besser als erwartet (${Math.round(luck * 100)} %).`, 'good'); }
  const side = L.fx?.side || {};
  const hurt = Object.keys(side).filter((k) => side[k] >= 2 && ISS[k]);
  if (hurt.length) log(`Zielkonflikt: „${L.t}“ verschärft ${hurt.map((k) => ISS[k].n).join(', ')}.`, 'bad');
  // Synergien: ein Gesetz zum Partner-Problem ist schon in Kraft
  const has = (iss: string) => S.laws.some((x: any) => x !== L && x.iss === iss && ['kraft', 'done'].includes(x.stage) && !x.rep && !x.bestand);
  S.syn = S.syn || [];
  for (const sy of SYNERGY) {
    const key = sy.a + '+' + sy.b;
    if (S.syn.includes(key)) continue;
    if ((L.iss === sy.a && has(sy.b)) || (L.iss === sy.b && has(sy.a))) {
      S.syn.push(key); applyEff(sy.e);
      log(`Zusammenspiel: ${sy.t}`, 'good'); press(OUTLETS[0].n, sy.t, .4);
    }
  }
}

/** Nach den sechs Monaten Einführung: manchmal zeigt sich eine Überraschung. */
export function onDone(L: any) {
  if (L.rep || L.bestand || L.surprise) return;
  if (rnd() >= .3) return;
  const f = L.fx || {}, st = L.iss ? S.issues[L.iss] : null, opts: (() => string)[] = [];
  if ((f.b || 0) <= -2) opts.push(() => { const x = Math.round((f.b || 0) * .25 * 10) / 10; S.lawB += x; return `Die Kosten von „${L.t}“ laufen aus dem Ruder: ${sg(x)} Mrd € pro Jahr zusätzlich.`; });
  if (((f.g || {}).unt || 0) >= 2 && st) opts.push(() => { st.sev = clamp(st.sev + 4, 0, 100); return `Mitnahmeeffekte: Ein Teil der Förderung aus „${L.t}“ verpufft, ${ISS[L.iss].n} bleibt drängender als erhofft.`; });
  if (S.issues.digital && (L.p && Object.keys(L.p).length >= 3)) opts.push(() => { S.issues.digital.sev = clamp(S.issues.digital.sev + 3, 0, 100); return `Neue Bürokratie: Die Anträge für „${L.t}“ sind kompliziert, Ämter und Bürger stöhnen.`; });
  if (st) opts.push(() => { st.sev = clamp(st.sev - 5, 0, 100); S.basis += .4; return `Erfolgsmeldung: „${L.t}“ übertrifft die Erwartungen. ${ISS[L.iss].n} entspannt sich spürbar.`; });
  if (!opts.length) return;
  const txt = opts[Math.floor(rnd() * opts.length)]();
  L.surprise = txt;
  const good = txt.startsWith('Erfolg');
  log(txt, good ? 'good' : 'bad'); press(OUTLETS[good ? 0 : 1].n, txt.split(':')[0] + `: „${L.t}“`, good ? .5 : -.4);
}
